var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconDuck = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.857 9.286 20.714 8c-.143-.286-.857-2-2.285-2C17 6 16 6.714 16 8c0 1.571.429 2.857.286 4.286-1-.143-1.857-.286-2.857-.286C11 12 4.143 14 3 13.714 3.857 18 7.429 20 12.714 20c2.286.143 4.715-.286 6.429-1.714C20.57 17 21 14.286 20 12.57c-.429-.714-.857-1.714-1-2.571 0-.286.286-.429.714-.286.429.143 1.857.143 2.857.143.143 0 .286 0 .429-.143 0-.143 0-.285-.143-.428z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDuck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-duck.36945e56.svg";
export { ForwardRef as ReactComponent };